import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { parseDataSQL } from '../../utils/dataJogo';

function statusBadge(s) {
  if (s === 'ENTREGUE') return <span className="badge badge-success">Entregue</span>;
  return <span className="badge badge-warning">Pendente</span>;
}

export default function AdminResgates() {
  const [resgates, setResgates] = useState([]);
  const [atualizando, setAtualizando] = useState(null);
  const [form, setForm] = useState({ status: 'ENTREGUE', observacao_admin: '' });
  const [msg, setMsg] = useState('');
  const [filtro, setFiltro] = useState('todos');

  useEffect(() => { carregar(); }, []);

  function carregar() {
    api.get('/premiacoes/resgates').then(setResgates).catch(() => {});
  }

  async function salvar(e) {
    e.preventDefault();
    setMsg('');
    try {
      await api.patch(`/premiacoes/resgates/${atualizando.id}`, form);
      setMsg('Status atualizado com sucesso!');
      setAtualizando(null);
      carregar();
    } catch (err) {
      setMsg(err.message);
    }
  }

  const lista = resgates.filter(r => {
    if (filtro === 'pendentes') return r.status === 'PENDENTE';
    if (filtro === 'entregues') return r.status === 'ENTREGUE';
    return true;
  });

  const totalPendentes = resgates.filter(r => r.status === 'PENDENTE').length;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
        <h2 className="admin-title" style={{ margin: 0 }}>Solicitações de Prêmios</h2>
        {totalPendentes > 0 && (
          <span style={{
            background: 'var(--danger)', color: '#fff', borderRadius: 20,
            padding: '3px 12px', fontSize: 13, fontWeight: 700,
          }}>
            {totalPendentes} pendente{totalPendentes > 1 ? 's' : ''}
          </span>
        )}
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[
          { key: 'todos', label: 'Todos' },
          { key: 'pendentes', label: '⏳ Pendentes' },
          { key: 'entregues', label: '✅ Entregues' },
        ].map(f => (
          <button
            key={f.key}
            onClick={() => setFiltro(f.key)}
            style={{
              padding: '7px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600,
              border: '1.5px solid var(--border)', cursor: 'pointer',
              background: filtro === f.key ? 'var(--primary)' : 'transparent',
              color: filtro === f.key ? '#fff' : 'var(--text2)',
              borderColor: filtro === f.key ? 'var(--primary)' : 'var(--border)',
            }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {atualizando && (
        <form onSubmit={salvar} className="admin-form">
          <h3>
            Atualizar resgate de <strong>{atualizando.usuario_nome}</strong>
            {' — '}<em>{atualizando.premiacao_nome}</em>
          </h3>
          <div className="form-row">
            <div className="form-group">
              <label>Status</label>
              <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                <option value="PENDENTE">Pendente</option>
                <option value="ENTREGUE">Entregue</option>
              </select>
            </div>
            <div className="form-group">
              <label>Observação (opcional)</label>
              <input
                value={form.observacao_admin}
                onChange={e => setForm({ ...form, observacao_admin: e.target.value })}
                placeholder="Ex: Entregue via WhatsApp em 12/06"
              />
            </div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-success">Confirmar</button>
            <button type="button" className="btn btn-secondary" onClick={() => setAtualizando(null)}>Cancelar</button>
          </div>
        </form>
      )}

      {lista.length === 0 && (
        <p style={{ color: 'var(--text2)', textAlign: 'center', padding: '40px 0' }}>
          Nenhuma solicitação encontrada.
        </p>
      )}

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Usuário</th>
              <th>WhatsApp</th>
              <th>Prêmio</th>
              <th>Pontos</th>
              <th>Solicitado em</th>
              <th>Status</th>
              <th>Obs.</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {lista.map(r => (
              <tr key={r.id} style={r.status === 'PENDENTE' ? { background: 'rgba(245,166,35,0.05)' } : {}}>
                <td>
                  <div>
                    <strong style={{ display: 'block', fontSize: 14 }}>{r.usuario_nome}</strong>
                    <span style={{ fontSize: 12, color: 'var(--text2)' }}>{r.usuario_email}</span>
                  </div>
                </td>
                <td>
                  {r.usuario_whatsapp
                    ? <a href={`https://wa.me/55${r.usuario_whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" style={{ color: 'var(--success)', fontSize: 13 }}>
                        📱 {r.usuario_whatsapp}
                      </a>
                    : <span style={{ color: 'var(--text2)', fontSize: 12 }}>—</span>}
                </td>
                <td style={{ fontWeight: 600 }}>{r.premiacao_nome}</td>
                <td style={{ color: 'var(--primary)', fontWeight: 700 }}>{r.pontuacao_necessaria} pts</td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>
                  {parseDataSQL(r.data_resgate).toLocaleString('pt-BR', {
                    day: '2-digit', month: '2-digit', year: 'numeric',
                    hour: '2-digit', minute: '2-digit',
                  })}
                </td>
                <td>{statusBadge(r.status)}</td>
                <td style={{ fontSize: 12, color: 'var(--text2)', maxWidth: 160 }}>
                  {r.observacao_admin || '—'}
                </td>
                <td>
                  <button
                    className="btn btn-primary"
                    style={{ fontSize: 12, padding: '6px 12px' }}
                    onClick={() => {
                      setAtualizando(r);
                      setForm({ status: r.status, observacao_admin: r.observacao_admin || '' });
                    }}
                  >
                    Atualizar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
